import type * as ng from 'angular';
import { HtmlSanitizer, markdownToSafeHtml } from '../util/safe-html';

/**
 * `<div gp-markdown="expr">` shows the markdown `expr` evaluates to, images
 * included: it renders notes, which people write, not model output.
 *
 * The HTML is assigned natively, not through $compile or jQuery's .html(), so
 * a `{{ }}` in the text stays text.
 */
export function markdownDirective(sanitize?: HtmlSanitizer): ng.IDirective {
    return {
        restrict: 'A',
        link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
            scope.$watch(attrs['gpMarkdown'], (value: unknown) => {
                element[0].innerHTML = typeof value === 'string' && value ? markdownToSafeHtml(value, { images: true, sanitize }) : '';
            });
        },
    };
}
